// @flow
import type { Country } from '../country';
import { genericPhoneNumber } from '@tectonics/commons/customer-form/generic-phone-number';
import { validateThaiPhoneNumber } from '@tectonics/prs/thailand/validation/thai-phone-number';

const THAI_PHONE_MASK = [
  /\d/, /\d/, /\d/, /\d/, /\d/,
  /\d/, /\d/, /\d/, /\d/, /\d/,
];

const THAILAND: Country = {
  code: 'th',
  customerForm: {
    phoneNumber: {
      ...genericPhoneNumber,
      mask: THAI_PHONE_MASK,
      validationFunction: validateThaiPhoneNumber,
      inputFieldName: 'thaiPhoneNumber',
    },
  },
  taxDisplay: {
    taxCode: 'th_vat',
    percentage: '7',
    label: 'VAT',
    tooltipLabel: '?',
    tooltipTextKey: 'volcanes.display.vatTooltip',
    testId: 'display_thai_tax_vat',
  },
};

export default THAILAND;
